import { Tooltip } from "primereact/tooltip";

import { FECHAR_TOOLTIP } from "./fechar-tooltip.constants";
import type { FecharTooltipProps } from "./types-fechar-tooltip";

/** Tooltip "Fechar" do X dos modais da aba; vai dentro do Dialog, que já tem o X montado. */
export function FecharTooltipView({ testId }: FecharTooltipProps) {
  return <Tooltip target={`[data-testid="${testId}"]`} {...FECHAR_TOOLTIP} />;
}
